import { useDispatch, useSelector } from "react-redux";

import { getAdviceStart } from "Store/advice/slice";
import { useCartSelector } from "Store/cart";
import { ReduxState } from "Store/rootReducer";
import { useUserIdentificationSelector } from "Store/userIdentification/userIdentificationSelectors";
import { isDefined } from "Utils/functions";
import { useEffect } from "react";

export const useHandleAdviceEdit = (): void => {
  const dispatch = useDispatch();
  const adviceState = useSelector((state: ReduxState) => state.advice);
  const { current: cart, isLoading: isCartLoading } = useCartSelector();
  const userIdentification = useUserIdentificationSelector();

  useEffect(() => {
    const hasAdviceAndPriceReponses =
      adviceState.adviceResult.current !== null ||
      adviceState.advicePriceCalculationResults.current !== null;
    const isLoading =
      adviceState.adviceResult.isLoading ||
      adviceState.advicePriceCalculationResults.isLoading ||
      isCartLoading;
    const customerDateOfBirth =
      userIdentification?.newCustomerResponse?.dateOfBirth;

    if (
      isDefined(cart) &&
      isDefined(cart.advice) &&
      isDefined(cart.advice.adviceProductValues) &&
      isDefined(customerDateOfBirth) &&
      !hasAdviceAndPriceReponses &&
      !isLoading
    ) {
      const { adviceProductValues } = cart.advice;
      dispatch(
        getAdviceStart({
          ...adviceProductValues,
          dateOfBirth: customerDateOfBirth,
        }),
      );
    }
  }, [cart, userIdentification]);
};
